/* eslint camelcase:0, @typescript-eslint/camelcase:0, @typescript-eslint/explicit-function-return-type: 0 */
import invariant from 'invariant';

import { getTMS, deriveFunnelName } from './utils';

interface TrackEvent {
  event_category?: string;
  event_action?: string;
  event_content?: string;
  funnel_name?: string;
  funnel_step?: string;
  funnel_step_name?: string;
}

const getWrappedData = ({
  event_category = 'content',
  event_action = 'onsite',
  event_content,
  funnel_name,
  funnel_step,
  funnel_step_name,
}: TrackEvent = {}): TrackEvent => {
  return {
    event_category,
    event_action,
    event_content,
    funnel_name,
    funnel_step,
    funnel_step_name: deriveFunnelName({
      name: funnel_name || '',
      step: funnel_step || '',
      stepName: funnel_step_name,
    }),
  };
};

function trackEvent(eventName: TrackEvent | string, data?: TrackEvent) {
  try {
    const track = getTMS('Event');

    if (!track) return;

    if (typeof eventName !== 'string' && !data) {
      return track(getWrappedData(eventName));
    }

    track(eventName, getWrappedData(data));
  } catch (error) {
    invariant(error, error);
  }
}

export default trackEvent;
